/**
 * SheetNodeType enum - extracted to break circular dependency between
 * sheetNode.ts and nodes/nodeStylesTypes.ts
 */
export enum SheetNodeType {
  PAGE = "PAGE",
  GROUP = "GROUP",
  DEFERRED_TABLE = "DEFERRED_TABLE",
  GEOMETRY = "GEOMETRY",
  TABLE = "TABLE",
  TABLE_CELL = "TABLE_CELL",
  ELEVATION_ANNOTATION_OVERLAY = "ELEVATION_ANNOTATION_OVERLAY",
  PERSPECTIVE_DRAWING = "PERSPECTIVE_DRAWING",
  ORTHOGRAPHIC_DRAWING = "ORTHOGRAPHIC_DRAWING",
  PLAN = "PLAN",
  BROCHURE_ELEVATION_OVERLAY = "BROCHURE_ELEVATION_OVERLAY",
}
